module.exports = __webpack_public_path__ + "static/media/speaking.fc265d0d.svg";